import { render, staticRenderFns } from "./AjoutTiers.vue?vue&type=template&id=5682809e&scoped=true"
import script from "./AjoutTiers.vue?vue&type=script&lang=js"
export * from "./AjoutTiers.vue?vue&type=script&lang=js"
import style0 from "./AjoutTiers.vue?vue&type=style&index=0&id=5682809e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5682809e",
  null
  
)

export default component.exports